
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35471',
  depVersions: {
  "documents-public-ui": "static-1.35471",
  "atom": "static-1.5511",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2918",
  "client-types": "static-1.507",
  "cssUtils": "static-1.1056",
  "customer-data-filters-ui": "static-1.41261",
  "customer-data-objects": "static-1.8127",
  "customer-data-property-utils": "static-1.8480",
  "documents-lib": "static-1.35476",
  "emoji-mart": "static-3.6",
  "flux-actions": "static-1.380",
  "FormsCommonComponents": "static-1.86771",
  "FormUrlGenerator": "static-2.5150",
  "foundations-theming-specialty": "static-1.2633",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6025",
  "hs-test-utils": "static-1.8472",
  "hub-http": "static-1.6643",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12234",
  "HubStyleTokens": "static-2.11927",
  "I18n": "static-7.1698",
  "icons": "static-2.699",
  "jasmine-immutable": "static-1.3377",
  "jasmine-runner": "static-1.6885",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7584",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3320",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5813",
  "quartz": "static-1.7611",
  "react": "static-7.202",
  "react-dlb": "static-1.93",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17169",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5636",
  "react-virtualized": "static-2.111",
  "reference-resolvers": "static-1.8613",
  "reference-resolvers-lite": "static-1.8541",
  "reporting-data": "static-1.69241",
  "reporting-reports": "static-1.68917",
  "reporting-snowflake": "static-1.57857",
  "reporting-testing-lib": "static-1.11174",
  "reporting-visualizations": "static-1.61315",
  "reselect": "static-3.16",
  "sales-content-partitioning": "static-1.9393",
  "sanitize": "static-1.4907",
  "sanitize-text": "static-1.8590",
  "SharedI18nStrings": "static-1.187",
  "SharedLegalStrings": "static-1.2163",
  "signup-constants": "static-1.19866",
  "signup-ui-url-generator": "static-2.8492",
  "StyleGuideUI": "static-3.514",
  "superstore": "static-1.5192",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5182",
  "ui-addon-form-validation": "static-1.11342",
  "ui-asset-management-lib": "static-1.11537",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8873",
  "usage-tracker": "static-1.7748",
  "usage-tracker-container": "static-1.7738",
  "usage-tracker-core": "static-1.7598",
  "viral-links-lib": "static-1.7513",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10079",
  "foundations-components": "static-1.8683",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1389",
  "quartz-core": "static-1.6830",
  "quick-fetch": "static-1.4204",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "rpc-client-utils": "static-1.5104",
  "ui-addon-i18n": "static-1.11580",
  "ui-addon-upgrades": "static-9.18525",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3888",
  "quartz-webpack": "static-1.3835",
  "foundations-assets": "static-1.5320",
  "foundations-theming": "static-1.4917",
  "hub-http-janus": "static-1.901",
  "hub-http-shared-msw-handlers": "static-1.10835",
  "hubspotter-http": "static-1.4948",
  "sassPrefix": "static-1.324",
  "conversations-skeleton-state": "static-1.7603",
  "crm-message-bus": "static-1.44024",
  "customer-data-filters-ui-msw-helpers": "static-1.23696",
  "customer-data-objects-ui-components": "static-1.13464",
  "customer-data-reference-ui-components": "static-1.13601",
  "customer-data-ui-utilities": "static-1.10267",
  "events-data-lib": "static-1.680",
  "framework-builder-read-service-client": "static-1.4307",
  "hs-resources": "static-1.631",
  "immer": "static-1.105",
  "inbound-db-meta-service-client": "static-1.3752",
  "inbound-db-properties-service-client": "static-1.4125",
  "multi-account-reference-resolvers": "static-1.1438",
  "onboarding-scopes": "static-1.6888",
  "onboarding-tours": "static-1.17338",
  "pulse": "static-1.1076",
  "reporting-datasets-permissions-lib": "static-1.14699",
  "segments-client-types": "static-1.12042",
  "stylex": "static-1.46",
  "trellis-assets": "static-1.2994",
  "trellis-components": "static-1.3013",
  "trellis-theming": "static-1.1421",
  "ui-addon-teams": "static-1.21970",
  "quartz-auth": "static-1.1286",
  "ui-business-units-lib": "static-1.9531",
  "usage-tracker-session-replay": "static-1.5434",
  "ai-components-ui-library": "static-1.9951",
  "ContentUtils": "static-1.69388",
  "customer-data-properties": "static-1.52940",
  "forms-ai-lib": "static-1.4923",
  "forms-utils-lib": "static-1.13273",
  "foundations-components-test-utils": "static-1.6166",
  "react-dnd-compat": "static-1.5044",
  "react-tinymce": "static-1.56202",
  "tinymce-config": "static-2.55328",
  "ui-gdpr-components": "static-1.10651",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3902",
  "HeadJS": "static-2.816",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3583",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.374",
  "ui-fonts": "static-1.1189",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4741",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1276",
  "web-vitals": "static-1.19",
  "batch-promise": "static-1.1980",
  "external-options-client-types": "static-1.4423",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1286",
  "frontend-preferences-client": "static-1.8351",
  "graphql": "static-1.93",
  "persist-promise": "static-1.4137",
  "reporting-client-types": "static-1.2799",
  "apollo-stack-hubspot": "static-3.98",
  "growth-payments-core": "static-1.26432",
  "hubspot-apollo-client": "static-1.5312",
  "foundations-components-legacy": "static-1.1708",
  "quartz-routing": "static-1.1041",
  "hs-story-utils": "static-1.9858",
  "react-flip-move": "static-1.82",
  "nested-table": "static-1.669",
  "seat-types-lib": "static-1.975",
  "timezone-utils": "static-2.5665",
  "react-create-root-preference": "static-1.96",
  "bend-plugin-foundations-components": "static-1.4952",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "tanstack-table": "static-1.65",
  "opentelemetry-fe-types": "static-1.221",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.599",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.596",
  "quartz-test": "static-1.1286",
  "quartz-tracking": "static-1.990",
  "bend-plugin-chirp-manifest": "static-1.514",
  "chirp-fetch": "static-1.2336",
  "merchandise-lib": "static-1.283",
  "purchase-motions-components": "static-1.6583",
  "ts-schema": "static-1.4374",
  "bender-build-tools": "static-1.3518",
  "bend-plugin-foundations-theming": "static-1.3400",
  "restore-request-side-panel-lib": "static-1.1952",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5022",
  "conditional-properties-service-client": "static-1.4094",
  "crm-pipelines-api-client-types": "static-1.4425",
  "event-emitter": "static-1.1395",
  "fdsr-migration-layer": "static-1.445",
  "multi-currency-client-types": "static-1.3990",
  "getting-started-shared-tasks": "static-1.19493",
  "growth-data-modal": "static-1.6075",
  "growth-onboarding-confetti": "static-1.3496",
  "growth-onboarding-next-action-utils": "static-1.2917",
  "navigation-components": "static-1.19090",
  "onboarding-tours-client": "static-1.5553",
  "onboarding-tours-utils": "static-1.1405",
  "ui-shepherd-react": "static-3.10709",
  "ui-shepherd-tracker": "static-1.8090",
  "ui-universal-auth": "static-1.9650",
  "user-context": "static-1.5487",
  "bend-plugin-pulse": "static-1.579",
  "fast-json-patch": "static-1.74",
  "crm-index-associations-lib": "static-1.6882",
  "stylex-utils": "static-1.166",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "hubspotter-http-shared-msw-handlers": "static-1.10833",
  "magpie-lib": "static-1.5871",
  "navigation-messaging": "static-1.8417",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23603",
  "copilot-toolkit": "static-1.12075",
  "cms-field-types": "static-1.5246",
  "content-icons-ui": "static-1.2418",
  "integrations-lib": "static-1.17332",
  "calling-global-api": "static-1.66077",
  "calling-internal-common": "static-1.31759",
  "calling-lifecycle-internal": "static-1.67459",
  "calling-lifecycle-messages": "static-1.59752",
  "commerce-products-lib": "static-1.10802",
  "crm-index-visualization-core": "static-1.4701",
  "crm-links": "static-1.6739",
  "customer-data-properties-shared-msw-handlers": "static-1.10162",
  "file-manager-components": "static-1.24770",
  "formula-editor": "static-1.14957",
  "framework-data-schema-resolvers": "static-1.7326",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4504",
  "meetings-icalendar-utils-lib": "static-1.1071",
  "object-builder-ui-client": "static-1.49965",
  "pipeline-validation-client-types": "static-1.4262",
  "property-value-citations": "static-1.3554",
  "smart-data-capture-core": "static-1.398",
  "smart-property-lib": "static-1.8557",
  "tiered-pricing": "static-1.2168",
  "topics-actions-lib": "static-1.610",
  "trellis-ext-i18n": "static-1.1324",
  "trial-components-library": "static-1.14314",
  "ui-addon-iframeable": "static-1.9511",
  "zustand": "static-1.88",
  "final-form": "static-1.82",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.82",
  "rich-text-lib": "static-1.20494",
  "tinymce-themes": "static-1.57298",
  "data-token-picker": "static-1.17067",
  "hub-http-contrib": "static-1.3462",
  "interframe": "static-3.5174",
  "tinymce-data": "static-1.41413",
  "tinymce-plugins": "static-1.58442",
  "ui-addon-sales-email": "static-1.5636",
  "ui-addon-opt": "static-4.8821",
  "hubspot-apollo-cache": "static-1.771",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.582",
  "opentelemetry-web": "static-1.22",
  "beacon-keepalive-queue": "static-1.134",
  "purchase-motions-api": "static-1.6586",
  "onboarding-data-sync-lib": "static-1.2778",
  "growth-onboarding-next-action-components": "static-1.2945",
  "user-context-client": "static-1.4943",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5331",
  "nest": "static-1.669",
  "reactive-lib": "static-1.1157",
  "simple-logging-lib": "static-1.3487",
  "unified-auth-core-lib": "static-1.1446",
  "getting-started-shared-tasks-store": "static-1.18611",
  "nav-meta": "static-1.30727",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2043",
  "integrations-error-boundary-lib": "static-1.14747",
  "integrations-tracking-lib": "static-1.6047",
  "native-integrations-shared-strings": "static-1.8197",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10805",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1164",
  "calling-error-reporting": "static-1.31766",
  "shared-worker-versioning": "static-1.11475",
  "calling-usage-tracker": "static-1.6968",
  "voice-sms-access-library": "static-1.2354",
  "customer-data-tracking": "static-1.7306",
  "commerce-permissions": "static-1.1216",
  "products-iframe-lib": "static-1.8831",
  "products-ui-components-shared-msw-handlers": "static-1.11217",
  "framework-data-schema-quick-fetch": "static-1.7231",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10918",
  "sales-views-client-types": "static-1.4692",
  "location-customization-utils-lib": "static-1.10349",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4575",
  "poll-commands": "static-1.3908",
  "video-components-external": "static-1.12362",
  "video-data-lib": "static-1.36020",
  "bark-lib": "static-1.16965",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6323",
  "react-codemirror": "static-1.11075",
  "data-agent-kit": "static-1.840",
  "data-agent-test-utils": "static-1.384",
  "data-agent-utils": "static-1.853",
  "feedback-loader": "static-1.30001",
  "fsm": "static-1.4191",
  "policy-lib": "static-1.7241",
  "react-colorpicker": "static-2.10646",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10981",
  "embedded-academy-lib": "static-1.15907",
  "hubs-service-types": "static-1.1699",
  "nudge-client-utils": "static-1.3349",
  "salesImages": "static-1.690",
  "FileManagerLib": "static-1.40410",
  "NamespacedHubStyle": "static-2.9341",
  "FileManagerCore": "static-1.40269",
  "content-assistance-lib": "static-1.8363",
  "layout-dnd-components": "static-1.13157",
  "layout-dnd-utils": "static-1.12132",
  "ui-addon-emoji-picker": "static-1.10300",
  "ui-brand-identity-lib": "static-1.16855",
  "InboxConnectUtils": "static-4.15778",
  "meetings-connect-utils-lib": "static-1.8050",
  "breeze-engine-chat-components": "static-1.1021",
  "breeze-engine-core": "static-1.1321",
  "ably": "static-2.2",
  "highlight.js": "static-1.90",
  "universal-page-editor-lib": "static-1.3442",
  "adobe-sign-auth-lib": "static-1.697",
  "ads-unified-auth-lib": "static-1.1826",
  "custom-vendor-connection-lib": "static-1.214",
  "google-sheets-integration-lib": "static-1.1265",
  "microsoft-drive-auth-lib": "static-1.423",
  "surveymonkey-integration-lib": "static-1.792",
  "slack-ui-library": "static-1.10831",
  "calling-orchestration-schema": "static-1.37131",
  "crm-record-cards-service-types": "static-1.3847",
  "content-media-composition-data-lib": "static-1.13518",
  "content-media-compositions": "static-2.17525",
  "media-bridge-lib": "static-1.19584",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16598",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4936",
  "enrichment-settings-lib": "static-1.170",
  "storybook-react": "static-1.44",
  "academy-common-lib": "static-1.15367",
  "nudge-custom-function-registry": "static-1.3106",
  "nudge-renderer-utils": "static-1.3425",
  "whisper-core-api": "static-1.7571",
  "audio-components": "static-1.6513",
  "FileManagerImages": "static-1.37921",
  "video-components": "static-1.14364",
  "breeze-artifacts-sdk": "static-1.759",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4949",
  "video-embed": "static-1.36854",
  "ui-addon-video-player": "static-1.9058",
  "ui-coaching-tips": "static-1.29534",
  "ContentData": "static-1.69463",
  "layout-data-lib": "static-1.10457",
  "academy-service-client": "static-1.4127",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4827",
  "trellis-ecosystem": "static-1.7792",
  "ui-addon-react-router-dom": "static-1.9963",
  "wootric-nps": "static-1.7275",
  "social-insights-client-types": "static-1.22870",
  "outpost": "static-1.4567",
  "growth-onboarding-feedback-components": "static-1.7017",
  "advanced-menus-core": "static-1.15753",
  "advanced-menus-lib": "static-1.12516",
  "ExportDialog": "static-6.10806",
  "ui-memberships-settings-lib": "static-1.35109",
  "marketplace-ui-apps-core": "static-1.19515",
  "marketplace-ui-common": "static-1.20983",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15752",
  "simple-menus-lib": "static-1.17269",
  "settings-ui-lib": "static-1.12964",
  "developer-experience-shared-components": "static-1.10973",
  "immutable-less": "static-1.5086",
  "marketplace-ui-client-types": "static-1.18390",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-extensibility-client-types": "static-1.4350",
  "ai-settings-ui-library": "static-1.8519",
  "ui-product-approvals-common": "static-1.1479",
  "apps-service-types": "static-1.4081",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3759"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35471",
  "atom": "/atom/static-1.5511",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2918",
  "client-types": "/client-types/static-1.507",
  "cssUtils": "/cssUtils/static-1.1056",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41261",
  "customer-data-objects": "/customer-data-objects/static-1.8127",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8480",
  "documents-lib": "/documents-lib/static-1.35476",
  "emoji-mart": "/emoji-mart/static-3.6",
  "flux-actions": "/flux-actions/static-1.380",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86771",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5150",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2633",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6025",
  "hs-test-utils": "/hs-test-utils/static-1.8472",
  "hub-http": "/hub-http/static-1.6643",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12234",
  "HubStyleTokens": "/HubStyleTokens/static-2.11927",
  "I18n": "/I18n/static-7.1698",
  "icons": "/icons/static-2.699",
  "jasmine-immutable": "/jasmine-immutable/static-1.3377",
  "jasmine-runner": "/jasmine-runner/static-1.6885",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7584",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3320",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5813",
  "quartz": "/quartz/static-1.7611",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17169",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5636",
  "react-virtualized": "/react-virtualized/static-2.111",
  "reference-resolvers": "/reference-resolvers/static-1.8613",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8541",
  "reporting-data": "/reporting-data/static-1.69241",
  "reporting-reports": "/reporting-reports/static-1.68917",
  "reporting-snowflake": "/reporting-snowflake/static-1.57857",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11174",
  "reporting-visualizations": "/reporting-visualizations/static-1.61315",
  "reselect": "/reselect/static-3.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9393",
  "sanitize": "/sanitize/static-1.4907",
  "sanitize-text": "/sanitize-text/static-1.8590",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2163",
  "signup-constants": "/signup-constants/static-1.19866",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8492",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "superstore": "/superstore/static-1.5192",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5182",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11342",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11537",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8873",
  "usage-tracker": "/usage-tracker/static-1.7748",
  "usage-tracker-container": "/usage-tracker-container/static-1.7738",
  "usage-tracker-core": "/usage-tracker-core/static-1.7598",
  "viral-links-lib": "/viral-links-lib/static-1.7513",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10079",
  "foundations-components": "/foundations-components/static-1.8683",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1389",
  "quartz-core": "/quartz-core/static-1.6830",
  "quick-fetch": "/quick-fetch/static-1.4204",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "rpc-client-utils": "/rpc-client-utils/static-1.5104",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11580",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18525",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3888",
  "quartz-webpack": "/quartz-webpack/static-1.3835",
  "foundations-assets": "/foundations-assets/static-1.5320",
  "foundations-theming": "/foundations-theming/static-1.4917",
  "hub-http-janus": "/hub-http-janus/static-1.901",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10835",
  "hubspotter-http": "/hubspotter-http/static-1.4948",
  "sassPrefix": "/sassPrefix/static-1.324",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7603",
  "crm-message-bus": "/crm-message-bus/static-1.44024",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23696",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13464",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13601",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10267",
  "events-data-lib": "/events-data-lib/static-1.680",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4307",
  "hs-resources": "/hs-resources/static-1.631",
  "immer": "/immer/static-1.105",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3752",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4125",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1438",
  "onboarding-scopes": "/onboarding-scopes/static-1.6888",
  "onboarding-tours": "/onboarding-tours/static-1.17338",
  "pulse": "/pulse/static-1.1076",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14699",
  "segments-client-types": "/segments-client-types/static-1.12042",
  "stylex": "/stylex/static-1.46",
  "trellis-assets": "/trellis-assets/static-1.2994",
  "trellis-components": "/trellis-components/static-1.3013",
  "trellis-theming": "/trellis-theming/static-1.1421",
  "ui-addon-teams": "/ui-addon-teams/static-1.21970",
  "quartz-auth": "/quartz-auth/static-1.1286",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9531",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5434",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9951",
  "ContentUtils": "/ContentUtils/static-1.69388",
  "customer-data-properties": "/customer-data-properties/static-1.52940",
  "forms-ai-lib": "/forms-ai-lib/static-1.4923",
  "forms-utils-lib": "/forms-utils-lib/static-1.13273",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6166",
  "react-dnd-compat": "/react-dnd-compat/static-1.5044",
  "react-tinymce": "/react-tinymce/static-1.56202",
  "tinymce-config": "/tinymce-config/static-2.55328",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3902",
  "HeadJS": "/HeadJS/static-2.816",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3583",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.374",
  "ui-fonts": "/ui-fonts/static-1.1189",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4741",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1276",
  "web-vitals": "/web-vitals/static-1.19",
  "batch-promise": "/batch-promise/static-1.1980",
  "external-options-client-types": "/external-options-client-types/static-1.4423",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1286",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8351",
  "graphql": "/graphql/static-1.93",
  "persist-promise": "/persist-promise/static-1.4137",
  "reporting-client-types": "/reporting-client-types/static-1.2799",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "growth-payments-core": "/growth-payments-core/static-1.26432",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5312",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1708",
  "quartz-routing": "/quartz-routing/static-1.1041",
  "hs-story-utils": "/hs-story-utils/static-1.9858",
  "react-flip-move": "/react-flip-move/static-1.82",
  "nested-table": "/nested-table/static-1.669",
  "seat-types-lib": "/seat-types-lib/static-1.975",
  "timezone-utils": "/timezone-utils/static-2.5665",
  "react-create-root-preference": "/react-create-root-preference/static-1.96",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4952",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "tanstack-table": "/tanstack-table/static-1.65",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.221",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.599",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.596",
  "quartz-test": "/quartz-test/static-1.1286",
  "quartz-tracking": "/quartz-tracking/static-1.990",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.514",
  "chirp-fetch": "/chirp-fetch/static-1.2336",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-components": "/purchase-motions-components/static-1.6583",
  "ts-schema": "/ts-schema/static-1.4374",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3400",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1952",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4094",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4425",
  "event-emitter": "/event-emitter/static-1.1395",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.445",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3990",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19493",
  "growth-data-modal": "/growth-data-modal/static-1.6075",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3496",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2917",
  "navigation-components": "/navigation-components/static-1.19090",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5553",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1405",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10709",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8090",
  "ui-universal-auth": "/ui-universal-auth/static-1.9650",
  "user-context": "/user-context/static-1.5487",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.579",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6882",
  "stylex-utils": "/stylex-utils/static-1.166",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10833",
  "magpie-lib": "/magpie-lib/static-1.5871",
  "navigation-messaging": "/navigation-messaging/static-1.8417",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23603",
  "copilot-toolkit": "/copilot-toolkit/static-1.12075",
  "cms-field-types": "/cms-field-types/static-1.5246",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "integrations-lib": "/integrations-lib/static-1.17332",
  "calling-global-api": "/calling-global-api/static-1.66077",
  "calling-internal-common": "/calling-internal-common/static-1.31759",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67459",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59752",
  "commerce-products-lib": "/commerce-products-lib/static-1.10802",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4701",
  "crm-links": "/crm-links/static-1.6739",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10162",
  "file-manager-components": "/file-manager-components/static-1.24770",
  "formula-editor": "/formula-editor/static-1.14957",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7326",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4504",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1071",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49965",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4262",
  "property-value-citations": "/property-value-citations/static-1.3554",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.398",
  "smart-property-lib": "/smart-property-lib/static-1.8557",
  "tiered-pricing": "/tiered-pricing/static-1.2168",
  "topics-actions-lib": "/topics-actions-lib/static-1.610",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1324",
  "trial-components-library": "/trial-components-library/static-1.14314",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9511",
  "zustand": "/zustand/static-1.88",
  "final-form": "/final-form/static-1.82",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "rich-text-lib": "/rich-text-lib/static-1.20494",
  "tinymce-themes": "/tinymce-themes/static-1.57298",
  "data-token-picker": "/data-token-picker/static-1.17067",
  "hub-http-contrib": "/hub-http-contrib/static-1.3462",
  "interframe": "/interframe/static-3.5174",
  "tinymce-data": "/tinymce-data/static-1.41413",
  "tinymce-plugins": "/tinymce-plugins/static-1.58442",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5636",
  "ui-addon-opt": "/ui-addon-opt/static-4.8821",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.771",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.582",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.134",
  "purchase-motions-api": "/purchase-motions-api/static-1.6586",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2778",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2945",
  "user-context-client": "/user-context-client/static-1.4943",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5331",
  "nest": "/nest/static-1.669",
  "reactive-lib": "/reactive-lib/static-1.1157",
  "simple-logging-lib": "/simple-logging-lib/static-1.3487",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1446",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18611",
  "nav-meta": "/nav-meta/static-1.30727",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2043",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14747",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6047",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8197",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10805",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1164",
  "calling-error-reporting": "/calling-error-reporting/static-1.31766",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11475",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6968",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2354",
  "customer-data-tracking": "/customer-data-tracking/static-1.7306",
  "commerce-permissions": "/commerce-permissions/static-1.1216",
  "products-iframe-lib": "/products-iframe-lib/static-1.8831",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11217",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7231",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10918",
  "sales-views-client-types": "/sales-views-client-types/static-1.4692",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10349",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4575",
  "poll-commands": "/poll-commands/static-1.3908",
  "video-components-external": "/video-components-external/static-1.12362",
  "video-data-lib": "/video-data-lib/static-1.36020",
  "bark-lib": "/bark-lib/static-1.16965",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6323",
  "react-codemirror": "/react-codemirror/static-1.11075",
  "data-agent-kit": "/data-agent-kit/static-1.840",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.384",
  "data-agent-utils": "/data-agent-utils/static-1.853",
  "feedback-loader": "/feedback-loader/static-1.30001",
  "fsm": "/fsm/static-1.4191",
  "policy-lib": "/policy-lib/static-1.7241",
  "react-colorpicker": "/react-colorpicker/static-2.10646",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10981",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15907",
  "hubs-service-types": "/hubs-service-types/static-1.1699",
  "nudge-client-utils": "/nudge-client-utils/static-1.3349",
  "salesImages": "/salesImages/static-1.690",
  "FileManagerLib": "/FileManagerLib/static-1.40410",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9341",
  "FileManagerCore": "/FileManagerCore/static-1.40269",
  "content-assistance-lib": "/content-assistance-lib/static-1.8363",
  "layout-dnd-components": "/layout-dnd-components/static-1.13157",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12132",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10300",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16855",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15778",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8050",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1021",
  "breeze-engine-core": "/breeze-engine-core/static-1.1321",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.90",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3442",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.697",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1826",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.214",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1265",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.423",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.792",
  "slack-ui-library": "/slack-ui-library/static-1.10831",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37131",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3847",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13518",
  "content-media-compositions": "/content-media-compositions/static-2.17525",
  "media-bridge-lib": "/media-bridge-lib/static-1.19584",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16598",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4936",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.170",
  "storybook-react": "/storybook-react/static-1.44",
  "academy-common-lib": "/academy-common-lib/static-1.15367",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3106",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3425",
  "whisper-core-api": "/whisper-core-api/static-1.7571",
  "audio-components": "/audio-components/static-1.6513",
  "FileManagerImages": "/FileManagerImages/static-1.37921",
  "video-components": "/video-components/static-1.14364",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.759",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4949",
  "video-embed": "/video-embed/static-1.36854",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9058",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29534",
  "ContentData": "/ContentData/static-1.69463",
  "layout-data-lib": "/layout-data-lib/static-1.10457",
  "academy-service-client": "/academy-service-client/static-1.4127",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4827",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7792",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9963",
  "wootric-nps": "/wootric-nps/static-1.7275",
  "social-insights-client-types": "/social-insights-client-types/static-1.22870",
  "outpost": "/outpost/static-1.4567",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7017",
  "advanced-menus-core": "/advanced-menus-core/static-1.15753",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12516",
  "ExportDialog": "/ExportDialog/static-6.10806",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35109",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19515",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20983",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15752",
  "simple-menus-lib": "/simple-menus-lib/static-1.17269",
  "settings-ui-lib": "/settings-ui-lib/static-1.12964",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10973",
  "immutable-less": "/immutable-less/static-1.5086",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18390",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4350",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8519",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1479",
  "apps-service-types": "/apps-service-types/static-1.4081",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3759"
}
};
